import { render, staticRenderFns } from "./SearchSlider.vue?vue&type=template&id=24f6b64f&scoped=true"
import script from "./SearchSlider.vue?vue&type=script&lang=js"
export * from "./SearchSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6b64f",
  null
  
)

export default component.exports